import { useBusy } from '@/context/busy-context';
import { useLocalize } from '@hooks/use-localize';
import { useShell } from '@/context/shell-context';

const BusyOverlay = () => {
    const isBusy = useBusy();
    const t = useLocalize(useShell().languageData);

    if (!isBusy) return null;

    return (
        <div className="busy-overlay" role="alert" aria-live="assertive" aria-busy="true">
            <span className="busy-overlay__spinner" />
            <span className="sr-only">{t('Word_Loading', 'Loading')}</span>
        </div>
    );
};

export default BusyOverlay;
